import { render } from "./Users.vue?vue&type=template&id=f4da6b9a&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=f4da6b9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4da6b9a"

export default script